import { useStore } from '@nanostores/react'
import { useQuery } from '@tanstack/react-query'
import { api } from '~/services/api'
import { $userInfo } from '~/store/user-info'

export function useBalanceQuery() {
  const userInfo = useStore($userInfo)

  return useQuery({
    queryKey: ['balance'],
    queryFn: async () => {
      return await api.service.get('user/users/current').json<{
        coin: number
        gem: number
        updated_at: string
      }>()
    },
    enabled: !!userInfo,
  })
}
